import { EventEmitter } from './event_emitter';

export const emitter = new EventEmitter();
